import React from "react";
import { Container, Reveal, SectionHeading } from "@/components/primitives";
import Accordion from "@/components/Accordion";

export default function FaqSection({
  eyebrow = "Questions",
  title = "Frequently asked",
  intro,
  items,
  testid = "faq-section",
  bg = false,
}) {
  return (
    <section
      className={`border-b border-border py-20 md:py-28 ${bg ? "bg-secondary/40" : ""}`}
      data-testid={testid}
    >
      <Container className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <SectionHeading eyebrow={eyebrow} title={title} intro={intro} />
          </Reveal>
        </div>
        <div className="lg:col-span-7 lg:col-start-6">
          <Reveal delay={0.08}>
            <Accordion items={items} testid={`${testid}-acc`} />
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
